export const priceBlockStyles = {
  root: 'font-sans text-brand-950',
  size: {
    sm: 'text-sm font-semibold md:text-md',
    md: 'text-lg font-bold md:text-xl',
    lg: 'text-xl font-bold md:text-2xl',
  },
  secondary: 'mt-0.5 block text-sm font-normal text-brand-700',
} as const;
